const IS_ACTIVE_FULLSCREEN_AD_SLOT = true;
const isIOS = /(iPad|iPhone|iPod)/g.test(navigator.userAgent); /* eslint-disable-line */

const simulateClickLink = ($prevClickedLink, callback) => {
  const $link = document.createElement('a');

  $link.href = $prevClickedLink.href;

  if ($prevClickedLink.target && !isIOS) {
    $link.target = $prevClickedLink.target;
    $link.rel = $prevClickedLink.rel;
  }

  callback?.();
  $link.click();
};

export default (event, $link, callback) => {
  if (
    !IS_ACTIVE_FULLSCREEN_AD_SLOT ||
    !window.Ya?.adfoxCode?.create ||
    !document.getElementById('js-adfox-fullscreen')
  ) {
    return callback?.(); /* eslint-disable-line */
  }

  event?.preventDefault();
  $link?.classList?.add('js-disabled-link');

  window.handleCloseFullscreen = () => simulateClickLink($link, callback);
  window.Ya.adfoxCode.create({
    ...window.Site.secondaryAdfoxUnits,
    onStub: () => {
      if ($link) {
        $link?.classList?.remove('js-disabled-link');
        simulateClickLink($link, callback);
      }
    },
    onError: () => {
      if ($link) {
        $link?.classList?.remove('js-disabled-link');
        simulateClickLink($link, callback);
      }
    },
    onRender: () => {
      $link?.classList?.remove('js-disabled-link');
    }
  });
};
